export const SET_MESSAGE = 'setState_SET_MESSAGE';
export const SET_SELECTED_ECARD = 'setState_SET_SELECTED_ECARD';
export const SET_PRIVATE_REC = 'setState_SET_PRIVATE_CHECKED';